/* INVOICES */
export const ALERT_ADD = "@ALERT/ALERT_ADD";
export const ALERT_REMOVE = "@ALERT/ALERT_REMOVE";
export const ALERT_UPDATE = "@ALERT/ALERT_UPDATE";
export const ALERT_SET_LIST = "@ALERT/ALERT_SET_LIST";
export const ALERT_SET_DOM = "@ALERT/ALERT_SET_DOM";
